import { Component, Input, OnDestroy } from '@angular/core';
import { Position } from '@mri/types';
import { GenericResourceService } from '@mri/app/resources';
import { filter, mergeMap, Subject, Subscription, tap } from 'rxjs';
import { CardComponent } from '../../@theme/components/card/card.component';
import { RenderSpeedPipe, ToDateTimeFormatPipe } from '../../pipes';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';

type AttrItem = { value: string, type: string, key: string };

@Component({
  selector: 'app-position-show',
  templateUrl: './position-show.component.html',
  standalone: true,
  imports: [
    CardComponent,
    RenderSpeedPipe,
    MatMenuModule,
    MatDividerModule,
    ToDateTimeFormatPipe
  ],
  styleUrl: './position-show.component.scss'
})
export class PositionShowComponent implements OnDestroy {
  private _subscription = new Subscription();
  private _elementId$ = new Subject<string>();
  private _element$ = new Subject<Position>();

  position?: Position;
  attributes: Array<AttrItem> = [];
  properties: Array<AttrItem> = [];
  sensors: Array<AttrItem> = [];

  @Input() set elementId(value: string) {
    this._elementId$.next(value);
  }

  @Input() set element(value: Position) {
    this._element$.next(value);
  }

  constructor(
    private _genericRsrSrv: GenericResourceService
  ) {

    this._subscription.add(
      this._elementId$.pipe(
        filter(value => !!value),
        mergeMap(elementId => this._genericRsrSrv.getElement<Position>('positions', elementId)),
        tap(response => this._element$.next(response.object))
      ).subscribe()
    );

    this._subscription.add(
      this._element$.pipe(
        filter(value => !!value),
        tap(element =>  Object.assign(element.attributes || {}, { outdated: element.outdated, protocol: element.protocol })),
        tap(element => this.position = element),
        tap(() => this.attributes = this.generateAttributesList()),
        tap(() => this.properties = this.generatePropertiesList()),
        tap(() => this.sensors = this.generateSensorsList())
      ).subscribe()
    );
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  generateAttributesList() {
    if (!this.position) return [];
    return Object.keys(this.position?.attributes || {})
      .filter(key => key)
      .map(key => ({ key, value: this.position?.attributes?.[key], type: typeof this.position?.attributes?.[key] }));
  }

  generatePropertiesList() {
    if (!this.position) return [];
    return Object.keys(this.position?.properties || {})
      .filter(key => key)
      .map(key => ({ key, value: this.position?.properties?.[key], type: typeof this.position?.properties?.[key] }));
  }

  generateSensorsList() {
    if (!this.position) return [];
    return Object.keys(this.position?.sensors || {})
      .filter(key => key)
      .map(key => ({ key, value: this.position?.sensors?.[key], type: typeof this.position?.sensors?.[key] }));
  }


}
